'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _user = require('./user/user');

var _user2 = _interopRequireDefault(_user);

var _services = require('./services/services');

var _services2 = _interopRequireDefault(_services);

var _utils = require('./utils/utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonModule = _angular2.default.module('app.common', [_user2.default.name, _services2.default.name, _utils2.default.name]);

exports.default = commonModule;


// WEBPACK FOOTER //
// ./client/app/common/common.js